export function vehicleLabel(vehicle, index, vehicles) {
  let name = `${vehicle.name} - ${vehicle.version}`;

  if (vehicles.some(v => v.version === vehicle.version && v.id !== vehicle.id)) {
    name += ` - ${vehicle.fuel.name}`;
  }

  return {
    name,
    molicar_code: vehicle.molicar_code,
  };
}

export function vehicleGroupKey(vehicle) {
  return `${vehicle.vehicle_brand.name.trim()}|${vehicle.name.trim()}`;
}

export function vehicleYears(min, max) {
  const options = [];

  for (let i = max; i >= min; i -= 1) {
    options.push({
      label: i,
      value: i,
    });
  }

  return options;
}

export function every(target, array) {
  return target.every(item => array.includes(item));
}
